module.exports = {
  admin: "admin",
  superAdmin: "superAdmin",
  user: "user",
};
